import { render } from "./TransicaoEntreAbas.vue?vue&type=template&id=6262d9ca&scoped=true"
import script from "./TransicaoEntreAbas.vue?vue&type=script&lang=js"
export * from "./TransicaoEntreAbas.vue?vue&type=script&lang=js"

import "./TransicaoEntreAbas.vue?vue&type=style&index=0&id=6262d9ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6262d9ca"]])

export default __exports__